/**
 * Mobile menu
 */
const componentSearchOverlay = (args) => {

  // setup args
  let menu     = args.menu;
  let site     = args.site;
  let toggles  = args.toggles;

  // validate
  if (!menu || !site || !toggles.length) {
    console.log('Invalid search overlay args');
    return;
  }

  // setup a11y dialog
  const dialog = new A11yDialog(menu, site);

  // tasks to open menu visually
  const openMenu = () => {
   document.body.classList.add('is-active-search');
   		// Give CSS transition time to finish before setting focus
		setTimeout(function () {
			document.querySelector('.js-search-input').focus();
		}, 1000);
  };

  // tasks to close menu visually
  const closeMenu = () => {

    document.body.classList.add('is-closing-search');
    setTimeout(() => {
      document.body.classList.remove('is-active-search');
      document.body.classList.remove('is-closing-search');
     }, 200);

  };

  // hooks
  dialog.on('show', (element, event) => {
    openMenu();
  });
  dialog.on('hide', (element, event) => {
    closeMenu();
  });

  // click outside menu to close
  site.addEventListener('click', (e) => {
    if ((e.target.classList && !e.target.classList.contains('js-search-toggle')) && document.body.classList.contains('is-active-search')) {
      dialog.hide();
    }
  });

  // toggle click
  const handleToggle = (e) => {
    if (document.body.classList.contains('is-active-search')) {
       dialog.hide();
    } else {
      dialog.show();
    }
  };

  for (let i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', handleToggle, false);
  }

  // make the call chainable
  return this;

};

/**
 * Init mobile menu
 */
componentSearchOverlay({
  menu:     document.querySelector('.js-search-overlay'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-search-toggle')
});

const parseFetchResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;

      return Promise.reject(error);
    }

    return data;
  });
};

function search() {
	const config = window.emSearchConfig;

	if (typeof config === 'undefined') {
		throw new Error('Could not find the search configuration data.');
	}

	const modalEl = document.querySelector('.js-search-modal');
	const inputEl = document.querySelector('.js-search-input');
	const resultsEl = document.querySelector('.js-search-results');
	const itemsEl = document.querySelector('.js-search-items');

	const init = () => {

		if (inputEl !== null) {
			setupInputEvent();
		}
	};


	const setupInputEvent = () => {
		inputEl.addEventListener('keyup', (e) => {
			e.preventDefault();

			debounceInput(makeSearch, inputEl.value);
		});
	};

	const makeSearch = (str) => {
		if (str.length < config.minLength || str === window.currentSearch) {
			return false;
		}

		if (resultsEl === null || itemsEl === null) {
			throw new Error('Could not find required search elements.');
		}

		resetResults();

		// Get search results from the WordPress REST API
		const url = `${config.ajax_url}?action=${config.action}&s=${str}&lang=${config.language}`;
		const requestOptions = {
			method: 'GET',
		};

		window
			.fetch(`${url}`, requestOptions)
			.then(parseFetchResponse)
			.then((data) => {
				window.currentSearch = str;
				populateResults(data);

				// Pinging analytics with searchterm, but only if user typing has stopped
				if (inputEl.value === str && window.dataLayer) {
					window.dataLayer.push({
						event: 'internalSearch',
						eventAction: str,
						eventLabel: window.location.href,
					});
				}
			})
			.catch((error) => {
				throw new Error(error);
			});
	};

	const resetResults = () => {
		resultsEl.classList.add('is-loading');
		itemsEl.innerHTML = '';
	};

	const populateResults = (data) => {
		resultsEl.classList.remove('is-loading');

		if (!data.length) {
			itemsEl.innerHTML = `<h4 class="site-search-results__error">${config.text.noResults}</h4>`;

			return false;
		}

		const posts = data.map((post, index) => {
			return buildPost(post, index);
		});

		itemsEl.innerHTML = posts.join('');
	};

	const buildPost = (post, order) => {
		return `
      <div class="site-search-results__item animated fadeInUp delay--${order}">
        <div class="search-result search-result--${post.type}">
          <a href="${post.link}" class="search-result__link wrapper-link">
            <div class="search-result__header">
            <div class="search-result__label">${post.type_label}</div>
              <h3 class="search-result__title">${post.title}</h3>
            </div>
            <p class="search-result__excerpt">${post.excerpt}</p>
          </a>
        </div>
      </div>
    `;
	};
	const debounceInput = (callback, args) => {
		clearTimeout(window.emSearchInputTimeout);

		window.emSearchInputTimeout = setTimeout(() => {
			callback(args);
		}, 50);
	};

	// Initialize component
	init();
}

(() => {
	window.addEventListener('DOMContentLoaded', () => {
		search();
	});
})();



